<template>
  <i
    aria-hidden="true"
    class="fa"
    :class="[name]"
    :style="{ fontSize: fontSize + 'px' }"
  ></i>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'k-icon',
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {},
  computed: {},
  watch: {},
  components: {},
  props: {
    name: {
      type: String,
      required: true,
    },
    fontSize: {
      type: String,
      default: '14',
    },
  },
};
</script>
